var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 84,
    viewBox: "0 0 243 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.5,
    ry: 4.49859,
    transform: "matrix(-1 0 0 1 29.498 36.4986)",
    fill: "#E3E0FB"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.5,
    ry: 4.49859,
    transform: "matrix(-1 0 0 1 13.498 9.49859)",
    fill: "#E3E0FB"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.498,
    cy: 37.4986,
    rx: 4.5,
    ry: 4.49859,
    fill: "#E3E0FB"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.498,
    cy: 60.4986,
    rx: 4.5,
    ry: 4.49859,
    fill: "#E3E0FB"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.5,
    ry: 4.49859,
    transform: "matrix(-1 0 0 1 50.498 14.4986)",
    fill: "#E3E0FB"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.5,
    ry: 4.49859,
    transform: "matrix(-1 0 0 1 41.498 68.5025)",
    fill: "#E3E0FB"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 186.498,
    cy: 15.4986,
    rx: 4.5,
    ry: 4.49859,
    fill: "#E3E0FB"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 238.5,
    cy: 62.4986,
    rx: 4.5,
    ry: 4.49859,
    fill: "#E3E0FB"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.5,
    ry: 4.49859,
    transform: "matrix(-1 0 0 1 4.5 51.4986)",
    fill: "#E3E0FB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 228.498,
    cy: 17.5,
    r: 4.5,
    fill: "#E3E0FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.7585 0.121834C87.2272 0.672569 82.8543 2.75749 79.4904 5.98322C75.9881 9.34663 73.772 13.8902 73.1981 18.8074C72.9211 21.1481 72.9409 45.9249 73.2179 48.3639C73.772 53.3598 76.186 58.2181 79.7675 61.5225C82.2013 63.7451 85.7234 65.6923 88.6717 66.4201L89.9974 66.7544L90.0568 73.9927C90.0568 73.9927 90.0132 80.0514 90.7097 82.0963C91.4062 84.1412 94.2516 84.3976 95.9335 83.5321C96.3095 83.3355 107.464 73.2272 107.464 73.2272L114.427 67.1085H133.964C146.331 67.1085 147.143 67.0888 149.022 66.7151C158.045 64.8859 164.753 57.5493 165.782 48.3639C166.059 45.9249 166.079 21.1481 165.802 18.8074C165.01 12.0019 161.191 6.21924 155.216 2.73782C153.732 1.87238 151.337 0.928253 149.418 0.4562C147.697 0.0431442 147.558 0.0431519 120.39 0.0038147C105.372 -0.0158615 92.4906 0.0431595 91.7585 0.121834Z",
    fill: "#E3E0FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.384 18.0783C117.897 18.1955 117.528 18.4066 117.147 18.7817C116.766 19.1686 116.532 19.5848 116.426 20.0947C116.379 20.3116 116.362 21.947 116.362 25.382V30.3644H111.379C107.944 30.3644 106.308 30.382 106.091 30.4289C105.587 30.5344 105.165 30.7689 104.778 31.1499C103.741 32.1932 103.741 33.8169 104.778 34.8486C105.165 35.2296 105.587 35.4641 106.091 35.5754C106.308 35.6223 107.891 35.6399 111.379 35.6399H116.362V40.6223C116.362 44.0573 116.379 45.6927 116.426 45.9096C116.532 46.4195 116.766 46.8357 117.147 47.2167C118.196 48.2601 119.814 48.2601 120.846 47.2226C121.227 46.8357 121.462 46.4137 121.573 45.9096C121.62 45.6927 121.637 44.11 121.637 40.6223V35.6399H126.62C130.055 35.6399 131.691 35.6223 131.908 35.5754C132.418 35.4699 132.834 35.2355 133.215 34.8544C134.258 33.8052 134.258 32.1932 133.221 31.1499C132.834 30.763 132.377 30.5168 131.89 30.423C131.708 30.3878 129.604 30.3644 126.614 30.3644H121.637V25.382C121.637 21.947 121.62 20.3116 121.573 20.0947C121.467 19.5906 121.233 19.1686 120.852 18.7817C120.184 18.1135 119.287 17.8556 118.384 18.0783Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.24b24149f155db9a2ac073145330dbb5.svg";
export { ForwardRef as ReactComponent };